import { useDispatch, useSelector } from 'react-redux';

import { slices } from '~/redux/slices';

import { ModelAddScope } from './ModelAddScope';
import { ModelLibrary } from './ModelLibrary';

type Callback = () => void;

interface Props {
  onCancel: Callback;
}

export const XRayLibrary = ({ onCancel }: Props) => {
  const dispatch = useDispatch();

  const step = useSelector(slices.xRayLibrary.selectors.selectStep);

  const handleCancel = () => {
    onCancel();
    dispatch(slices.xRayLibrary.actions.setStep('model-library'));
  };

  switch (step) {
    case 'model-library':
    default:
      return (
        <ModelLibrary
          onCancel={handleCancel}
          onNext={() =>
            dispatch(slices.xRayLibrary.actions.setStep('add-scope'))
          }
        />
      );
    case 'add-scope':
    case 'confirm-publish':
      return (
        <ModelAddScope
          onBack={() =>
            dispatch(slices.xRayLibrary.actions.setStep('model-library'))
          }
          onCancel={handleCancel}
        />
      );
  }
};
